module.exports = __webpack_public_path__ + "img/A.9988fae8.jpg";